import { StyledButton } from './styled';

type GradientButtonProps = Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'children'> & {
  children: JSX.Element;
};

export default function GradientButton({ children, type, ...remainder }: GradientButtonProps) {
  return (
    <StyledButton {...remainder} type={type || 'button'}>
      {children}
    </StyledButton>
  );
}
